import API from "./API";

async function doPostUser(user) {
    return API.post('/website/users/', user);
}

async function doGetUserWithToken(token) {
    return API.post(`/registration/checktoken/${token}`);
}

async function doGetUserSubscriptions(id) {
    return API.get(`/users/${id}/subscriptions`);
}

async function doGetWhoAmI() {
    return API.get('/users/whoami/');
}

async function doGetUser(id) {
    return API.get(`/users/${id}`);
}

async function doGetSubscriptionHistory(id) {
    return API.get(`/users/${id}/subscriptions/history`);
}

async function doGetAvailableAddons(user_id) {
    return API.get(`/users/${user_id}/addons/available`);
}

async function doPostAddonsIntentRequest(user_id, addons) {
    let params = new URLSearchParams();
    params.append('addons', addons);
    return API.post(`/users/${user_id}/addons/purchase`, params);
}

export {
    doPostUser,
    doGetUserWithToken,
    doGetUserSubscriptions,
    doGetWhoAmI,
    doGetUser,
    doGetSubscriptionHistory,
    doGetAvailableAddons,
    doPostAddonsIntentRequest,
}